/* src/app/shared/components/sem-dynamic/sem-dynamic.component.css */
/*# sourceMappingURL=sem-dynamic.component.css.map */
